module.exports = __webpack_public_path__ + "static/logo-27119b33110887d18a37a46181a9b021.png";